import { List, Text } from '@mantine/core'

import { LegalPage } from './LegalPage'

/** `/cookies`: no sign-in needed. The source text is also kept in docs/legal/cookies.md; keep the two in sync. */
export function CookiesPage() {
  return (
    <LegalPage title="Cookies and local storage">
      <Text size="sm">
        Macrotide&apos;s web app uses no cookies for tracking or advertising, and no analytics. We do use your
        browser&apos;s local storage, strictly for what the app needs to work:
      </Text>
      <List size="sm">
        <List.Item>
          <b>Your sign-in session</b> — <code>macrotide.auth.session</code>
        </List.Item>
        <List.Item>
          <b>Settings</b> such as the trend method and active gym — <code>macrotide.trendMethod</code>,{' '}
          <code>macrotide.activeGym</code>
        </List.Item>
        <List.Item>
          <b>Drafts</b> of things you&apos;re editing, so a refresh doesn&apos;t lose them —{' '}
          <code>macrotide.draft.*</code>
        </List.Item>
        <List.Item>
          <b>The barcode cache</b>, so scanning the same product twice is instant — <code>macrotide.barcode.*</code>
        </List.Item>
        <List.Item>
          <b>Setup progress</b> — <code>macrotide.setupLater</code>, <code>macrotide.setupUnits</code>
        </List.Item>
      </List>
      <Text size="sm">
        All of these are strictly necessary for the app to function, under UK PECR / the ePrivacy Directive, so we
        don&apos;t need to show a cookie consent banner for them. If we ever add analytics, we&apos;ll ask first.
      </Text>
    </LegalPage>
  )
}
